import Pusher from "pusher-js";

import { AuthorizePusherChannelAPI } from "api/pusher";

let pusherClient = null;

export const getPusherClient = () => {
  if (pusherClient) {
    return pusherClient;
  }

  pusherClient = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,

    authorizer: (channel) => ({
      authorize: async (socketId, callback) => {
        try {
          const response = await AuthorizePusherChannelAPI({
            socket_id: socketId,
            channel_name: channel.name,
          });

          callback(false, response?.data);
        } catch (error) {
          callback(true, error);
        }
      },
    }),
  });

  return pusherClient;
};

export const disconnectPusherClient = () => {
  if (!pusherClient) return;

  pusherClient.disconnect();

  pusherClient = null;
};
